import { Component } from "@angular/core";
import { mdlAddSequnceNoReq } from "../../Models/mdlAddSequnceNoReq";
import { OtpVerifyReq } from "../../Models/OtpVerifyReq";
import { OtpVerifyRes } from "../../Models/OtpVerifyRes";
import { HttpClient } from "@angular/common/http";
import { motorProposalService } from "../../Services/motorProposalService";
import { restURL } from "../../Models/restURL";
import { LanguageService } from "../../Services/languageService";
import { userService } from "../../Services/userService";
import { TranslateService } from "@ngx-translate/core";
import { mdlPayloadRequest } from "../../Models/mdlPayloadRequest";
import { mdlPayloadResponse } from "../../Models/mdlPayloadResponse";
import Swal from 'sweetalert2';
import { ResendOTPMdl } from "../../Models/ResendOTPMdl";
import { MotorStatusMdl } from "../../Models/MotorStatusMdl";
import { Router } from "@angular/router";

@Component({
  selector: 'AddSequenceNo',
  templateUrl: './AddSequenceNo.html',
  styleUrls: ['./AddSequenceNo.css']
})

export class AddSequenceNo {

  public objAddSeqReq: mdlAddSequnceNoReq = new mdlAddSequnceNoReq();
  public isShowLoading: boolean;
  public otpReq: OtpVerifyReq = new OtpVerifyReq();
  public otpRes: OtpVerifyRes = new OtpVerifyRes();
  public objPayloadRequest: mdlPayloadRequest = new mdlPayloadRequest();
  public objPayloadResponse: mdlPayloadResponse = new mdlPayloadResponse();
  public resendObj: ResendOTPMdl = new ResendOTPMdl();
  public st: MotorStatusMdl = new MotorStatusMdl();
  public counter: number = 0;
  public timeLeft: number = 180;
  public isResendShow: boolean = false;
  public interval;
  public isShowTimer: boolean = false;
  public Lng: string;
  public showOTP: boolean = false;

  constructor(private router: Router,private url: restURL, private lngService: LanguageService, private userInfo: userService, private translate: TranslateService, private EncriptService: motorProposalService, private http: HttpClient, ) {
    if (sessionStorage.getItem("Language") != null) {
      this.Lng = sessionStorage.getItem("Language");
    }
    else {
      this.Lng = "en";
    }

    this.objAddSeqReq = JSON.parse(this.EncriptService.DecriptObject(sessionStorage.getItem("AddSeqPolicy")));
  }


  VerifyOTP() {

    this.otpReq.RegNo = Number(sessionStorage.getItem("RegNo"));

    this.isShowLoading = true;

    this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.otpReq));

    //this.http.post<OtpVerifyRes>(this.url.baseURL + "Registration/VerifyOTP", this.otpReq, this.userInfo.getHttpOptions()).toPromise().then(result => {
    this.http.post<mdlPayloadResponse>(this.url.baseURL + "Registration/LoginVerifyOTP", this.objPayloadRequest, this.userInfo.getHttpOptions()).toPromise().then(result => {
      //this.otpRes = result;
      this.isShowLoading = false;
      //New Line Start
      this.objPayloadResponse = result;
      this.otpRes = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
      //NewLine End





      // Swal(this.translate.instant(this.otpRes.st.StatusDesc));
      Swal({
        title: this.translate.instant(this.otpRes.st.StatusDesc),
        text: '',
        type: (this.otpRes.st.StatusCode == "S" ? 'success' : 'warning'),
        // showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        showCloseButton: true,
        timer: 5000
      })



    }, (error) => {
      this.isShowLoading = false;
      Swal(this.translate.instant("Please Try agian later."));
    });
  }


  ResendOTP() {

    this.counter += 1;
    if (this.counter > 5) {
      Swal(this.translate.instant("Maximum resend attempts reached. Please try again later"));
      return;
    }

    this.resendObj.RegNo = sessionStorage.getItem("RegNo");

    this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.resendObj));
    this.isShowLoading = true;
    //this.http.post<MotorStatusMdl>(this.url.baseURL + "Registration/ResendOTP", this.resendObj, this.userInfo.getHttpOptions()).toPromise().then((res) => {
    this.http.post<mdlPayloadResponse>(this.url.baseURL + "Registration/ResendOTP", this.objPayloadRequest, this.userInfo.getHttpOptions()).toPromise().then((res) => {
      this.isShowLoading = false;

      //New Line Start
      this.objPayloadResponse = res;
      this.st = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
      //NewLine End

      this.Lng == "ar" ? Swal(this.st.StatusDescAr) : Swal(this.st.StatusDesc);
      if (this.st.StatusCode == "S") {
        clearInterval(this.interval);
        this.timeLeft = 180;
        this.showOTPTimer();
        this.isResendShow = false;

      }

    }, (res) => {
      Swal("Try agian");
      this.isShowLoading = false;

    });
  }


  showOTPTimer() {
    this.isShowTimer = true;
    this.interval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
      } else if (this.timeLeft == 0) {
        this.timeLeft = 0;
        this.isResendShow = true;
      } else {
        this.timeLeft = 180;
      }
    }, 1000)
  }

  UpdateSequenceNo() {
   if(this.objAddSeqReq.SequenceNo==null ||this.objAddSeqReq.SequenceNo.length<6)
   {
    Swal({
      title: this.translate.instant("Please Enter Valid Sequence No"),
      text: '',
      type: ( 'warning'),
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      showCloseButton: true,
      timer: 5000
    })
    return;
   }
    this.isShowLoading = true;
    this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.objAddSeqReq));

    this.http.post<mdlPayloadResponse>(this.url.baseURL + "/Motor_Cancellation/SubmitAddSeqRequest", this.objPayloadRequest, this.userInfo.getHttpOptions()).toPromise().then(result => {
      this.isShowLoading = false;

      //New Line Start
      this.objPayloadResponse = result;
      let objMotorStatusMdl: MotorStatusMdl = new MotorStatusMdl();
      objMotorStatusMdl = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
      //NewLine End


      Swal({
        title: this.translate.instant(objMotorStatusMdl.StatusDesc),
        text: '',
        type: (this.otpRes.st.StatusCode == "S" ? 'success' : 'warning'),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        showCloseButton: true,
        timer: 5000
      })

      if (objMotorStatusMdl.StatusCode == "S") {
        this.router.navigate(['/NewDashboard/Policy']);
        return;
      }

    }, (error) => {
      this.isShowLoading = false;
      Swal(this.translate.instant("Please Try agian later."));
    });
  }

}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/AddSequenceNo/AddSequenceNo.ts